import React from 'react';
import styles from './SurveyPagination.module.scss';

export default function SurveyPagination({ currentPage, pages, onPageChange }) {
    return (
        <div className={styles.PaginationHost}>
            {[...Array(pages).keys()].map((i) => (
                <div
                    key={i}
                    className={`${styles.PaginationBlockHitbox} anl_survey--pagination-hitbox`}
                    onClick={() => onPageChange(i)}
                >
                    <div
                        className={
                            i === currentPage
                                ? `${styles.PaginationBlockActive} ${styles.PaginationBlock}`
                                : styles.PaginationBlock
                        }
                    />
                </div>
            ))}
        </div>
    );
}

SurveyPagination.defaultProps = {
    currentPage: 0,
    pages: 1,
};
